/* Represent-style Collection Page JS */
(function() {
  'use strict';

  /* ── Sort dropdown ────────────────────────────────── */
  var sortSelect = document.getElementById('rc-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ── Read more / less toggle ──────────────────────── */
  var descText = document.getElementById('rc-desc-text');
  var descWrap = document.getElementById('rc-desc');
  if (descText && descWrap && descText.scrollHeight > descText.clientHeight + 5) {
    var btn = document.createElement('button');
    btn.className = 'rc-info-bar__read-more';
    btn.textContent = 'Read more';
    btn.addEventListener('click', function() {
      var expanded = descText.classList.toggle('expanded');
      btn.textContent = expanded ? 'Read less' : 'Read more';
    });
    descWrap.appendChild(btn);
  }

  /* ── AJAX Quick-Add from size buttons ─────────────── */
  function showToast(message) {
    var existing = document.querySelector('.rc-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'rc-toast';
    toast.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg> ' + message;
    document.body.appendChild(toast);

    requestAnimationFrame(function() { toast.classList.add('rc-toast--show'); });
    setTimeout(function() {
      toast.classList.remove('rc-toast--show');
      setTimeout(function() { toast.remove(); }, 300);
    }, 2500);
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.rc-card__size-btn');
    if (!btn) return;
    if (btn.classList.contains('rc-card__size-btn--out')) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    e.preventDefault();
    e.stopPropagation();

    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      btn.textContent = '\u2713';
      showToast(data.title + ' added to bag');

      // Update cart count in header
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var counts = document.querySelectorAll('.cart-count-badge, [data-cart-count], .header__cart-count');
          counts.forEach(function(el) { el.textContent = cart.item_count; });
        });

      setTimeout(function() {
        var original = btn.getAttribute('data-original-text');
        if (!original) return;
        btn.textContent = original;
      }, 1500);
    })
    .catch(function() {
      btn.textContent = '!';
      setTimeout(function() {
        var original = btn.getAttribute('data-original-text');
        if (original) btn.textContent = original;
      }, 1500);
    });
  });

  // Store original text for restoration
  document.querySelectorAll('.rc-card__size-btn').forEach(function(btn) {
    btn.setAttribute('data-original-text', btn.textContent.trim());
  });
})();
